export enum SignedStatus {
  NOTSIGNED = 'NOTSIGNED',
  SIGNED = 'SIGNED',
}
